import React, { useEffect, useRef, useState } from "react";


import { Avatar, Button, Card } from 'antd';
const { Meta } = Card;
import  './bookdeal.css'
import { Link } from "react-router-dom";
import Header from "../../../Header/Header";
import SideBar from "../../../SideBar/SideBar";
import Footer from "../../../Footer/Footer";


export default function BookDealcopy() {

    const projcardRef = useRef(null);

    useEffect(() => {
      if (projcardRef.current) {
        const boxes = projcardRef.current.querySelectorAll(".projcard-description");
        boxes.forEach(box => clamp(box, { clamp: 6 }));
      }
    },[])
  return (
    <>
      <div className="main-wrapper">
        {/* Header */}
        <Header />

        {/* Sidebar */}
        <SideBar />

        {/* Page Wrapper */}
        <div className="page-wrapper">
          <div className="content container-fluid">
            {/* Page Header */}
            <div className="page-header">
              <div className="row align-items-center">
                <div className="col">
                  <h3 className="page-title mt-2">My Wishlist </h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/admindashboard">Dashboard</Link>
                    </li>
                    <li className="breadcrumb-item active">My Wishlist</li>
                  </ul>
                </div>
              </div>
            </div>
            {/* /Page Header */}
            <div className="card card-table">
              <div className="card-body">
                {/* <div className="row col-12"  style={{display:'flex', flexDirection:'row',alignItems:'center', justifyContent:'space-between'}}>
            
git 

                </div> */}
                <div class="projcard-container">
    
    <div class="projcard projcard-blue">
      <div class="projcard-innerbox">
        <img class="projcard-img" src="https://www.jeduka.com/storage/newsletter/1599896135_GRE.png" />
        <div class="projcard-textbox">
          <div class="projcard-title">Register Today and get upto 20% Off on GRE Examination</div>
          <div class="projcard-subtitle">Complete your registration and get ready to ace the exam</div>
          <div class="projcard-bar"></div>
          <div class="projcard-description">Make the Payment with the discounted Price and you will receive an email with the voucher code within 1 business days.</div>
          <div class="projcard-tagbox">
            <span class="projcard-tag">20%</span>
            <span class="projcard-tag">30%</span>     
          
          <Button type="primary" >Book Now</Button>
          </div>
        </div>
      </div>
    </div>
    
    <div class="projcard projcard-red">
      <div class="projcard-innerbox">
        <img class="projcard-img" src="https://banner2.cleanpng.com/20180622/egg/kisspng-test-of-english-as-a-foreign-language-toefl-sat-5b2d6fe16d3cc7.2114448715297044174475.jpg" />
        <div class="projcard-textbox">
          <div class="projcard-title">That's Another CardRegister Today and get upto 20% Off on GRE Examinatione" I don't really think that I need to explain anything here</div>
          <div class="projcard-bar"></div>
          <div class="projcard-description">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</div>
          <div class="projcard-tagbox">
            <span class="projcard-tag">PHP</span>
            <span class="projcard-tag">SQL</span>
            <span class="projcard-tag">Database</span>
          </div>
        </div>
      </div>
    </div>
    
    <div class="projcard projcard-green">
      <div class="projcard-innerbox">
        <img class="projcard-img" src="https://picsum.photos/800/600?image=1039" />
        <div class="projcard-textbox">
          <div class="projcard-title">And a Third Card</div>
          <div class="projcard-subtitle">You know what this is by now</div>
          <div class="projcard-bar"></div>
          <div class="projcard-description">Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident.</div>
          <div class="projcard-tagbox">
            <span class="projcard-tag">Excel</span>
            <span class="projcard-tag">VBA</span>
          </div>
        </div>
      </div>
    </div>
    
    <div class="projcard projcard-customcolor" >
      <div class="projcard-innerbox">
        <img class="projcard-img" src="https://picsum.photos/800/600?image=943" />
        <div class="projcard-textbox">
          <div class="projcard-title">Last Card</div>
          <div class="projcard-subtitle">That's the last one. Have a nice day!</div>
          <div class="projcard-bar"></div>
          <div class="projcard-description">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</div>
          <div class="projcard-tagbox">
            <span class="projcard-tag">iOS</span>
            <span class="projcard-tag">Android</span>
            <span class="projcard-tag">Cordova</span>
          </div>
        </div>
      </div>
    </div>
    
  </div>
              </div>
            </div>
          </div>
          {/* Footer */}
          <Footer />
        </div>
      </div>
      {/* /Main Wrapper */}
    </>
  );
}
